/**
 * 
 * @param {Object} sortable 
 * @returns {String}
 */
const sortAndStringify = (sortable) => {
  let ordered = {}

  Object.keys(sortable)
    .sort()
    .forEach((key) => {
      ordered[key] = sortable[key]
    })
  
  return JSON.stringify(ordered)
} 

export default sortAndStringify